<template>
  <div class="about-view">
    <About/>
  </div>
</template>
    
<script>
import About from '@/components/About/About.vue'
export default {
  components: {
    About
  },
};
</script>

<style lang="scss" scoped>
.about-view {
  width: 100%;
  background: #f5f5f5;
  min-height: 100vh;
  padding: 32px 0;
}

@media (max-width: 600px) {
  .about-view {
    padding: 24px 0;
  }
}
</style>
    